import { render, staticRenderFns } from "./SimulacionSlider.vue?vue&type=template&id=6f444728&scoped=true"
import script from "./SimulacionSlider.vue?vue&type=script&lang=js"
export * from "./SimulacionSlider.vue?vue&type=script&lang=js"
import style0 from "./SimulacionSlider.vue?vue&type=style&index=0&id=6f444728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f444728",
  null
  
)

export default component.exports